import React, { Fragment } from "react";
import { Text, View } from "react-native";
import { Avatar } from "../ui/avatar";
import { useFormatDate } from "@/elements/hooks/use-format-date";
import RemoteIcon from "@/assets/svgs/remote-icon";
import UserIcon from "@/assets/svgs/user-icon";
import ClockIcon from "@/assets/svgs/clock-icon";
import { api } from "../utils/convex-api";

function StudentBookingCard({
  booking,
}: {
  booking: NonNullable<typeof api.parent.home.queries.pendingBookings._returnType>[0];
}) {
  const fmt = useFormatDate();
  return (
    <Fragment>
      <View
        key={booking._id}
        className="border border-gray-200 p-4 rounded-[17px] gap-4"
      >
        <View className="flex-row items-center justify-between">
          <View className="flex-row items-center gap-2">
            <Text
              className={`font-geologica-medium font-medium text-base text-gray-800 leading-[1.5]`}
            >
              {booking.subject}
            </Text>
          </View>
          <Fragment>
            <Text
              className={`font-geologica-medium font-medium text-base text-gray-800 leading-[1.2]`}
            >
              {fmt(booking.startTime, "do MMMM")}
            </Text>
          </Fragment>
        </View>

        <View className="flex-row items-center justify-between">
          <View className="flex-row items-center gap-2">
            <Avatar size="sm" className="h-6 w-6">
              <Avatar.Content
                label={booking.tutor.firstName ?? ""}
                labelSize="sm"
                size="sm"
              />
            </Avatar>
            <Text
              className={`font-geologica-regular font-normal ${"text-gray-800"} text-sm leading-[1.5]`}
            >
              {booking.tutor.firstName}
            </Text>
          </View>

          <View className="flex-row items-center gap-[6px]">
            {booking.type === "in_person" ? (
              <UserIcon className="size-4" pathClassName={"stroke-gray-800"} />
            ) : (
              <RemoteIcon
                className="size-4"
                pathClassName={"stroke-gray-800"}
              />
            )}
            <Text
              className={`font-geologica-regular font-normal ${"text-gray-800"} text-sm leading-[1.5]`}
            >
              {booking.type === "in_person" ? "In person" : "Remote"}
            </Text>
          </View>

          <View className="flex-row items-center gap-2">
            <ClockIcon className="size-4" pathClassName={"stroke-gray-800"} />
            <Text
              className={`font-geologica-regular font-normal ${"text-gray-800"} text-sm leading-[1.5]`}
            >
              {fmt(booking.startTime, "HH:mm")} -{" "}
              {fmt(booking.endTime, "HH:mm")}
            </Text>
          </View>
        </View>
      </View>
    </Fragment>
  );
}

export default StudentBookingCard;
